import React from 'react';
import useEditMentor from '../../../hooks/api/mentors/useEditMentor';
import { userIsOnTrial } from '../../../utils/shared';
import SubmitBtn from '../../../components/SubmitBtn/SubmitBtn';
import { useTriggers } from '../../../hooks/navigation';

export default function MentorSettings() {
  const {
    mentor,
    handleChange,
    handleSubmit,
    handleCheckChange,
    saving,
    handleFileChange,
    mentorImgSrc,
    handleTriggerFileUpload,
    handleRemoveImage,
    mentorCategories,
  } = useEditMentor();

  const { handleOpenFreeTrialModal } = useTriggers();

  return (
    <div className="w-layout-vflex edit-mentor-setting-tab">
      <div className="secret-key-form-block edit-mentor-settings-form-block w-form">
        <form
          className="manage-account-form secret-key-form edit-mentor-settings-form"
          data-name="Email Form 2"
          data-wf-element-id="caf6ebbd-0b06-053d-0a1e-1eebea90b02a"
          data-wf-page-id="650305782bc61751e5765214"
          id="email-form-2"
          method="get"
          name="email-form-2"
        >
          <div className="w-layout-hflex flex-block-81">
            <div className="w-layout-vflex flex-block-82">
              <div className="w-layout-vflex input-block invite-user-secret-block edit-mentor-settings-form-input-block">
                <div className="w-layout-hflex flex-block-19">
                  <label className="form-input-label" htmlFor="name-6">
                    Name
                  </label>
                </div>
                <input
                  className="form-input secret-key-form-input edit-mentor-settings-form-input black-bg-white-color-form-field w-input"
                  custom-value="Personal"
                  data-name="Organisation Name 4"
                  id="organisation-name-4"
                  maxLength={256}
                  name="organisation-name-4"
                  defaultValue={mentor?.name}
                  placeholder="Mentor Name"
                  disabled={true}
                  type="email"
                />
              </div>
              <div className="w-layout-vflex input-block invite-user-secret-block edit-mentor-settings-form-input-block">
                <div className="w-layout-hflex flex-block-19">
                  <label className="form-input-label" htmlFor="name-6">
                    Description
                  </label>
                </div>
                <textarea
                  className="edit-mentor-settings-form-textarea black-bg-white-color-form-field textarea-medium-height w-input"
                  data-name="Field 8"
                  id="field-8"
                  maxLength={5000}
                  name="description"
                  value={mentor?.description}
                  onChange={handleChange}
                  placeholder="Mentor Description"
                ></textarea>
              </div>
              <div className="w-layout-vflex input-block invite-user-secret-block edit-mentor-settings-form-input-block">
                <div className="w-layout-hflex flex-block-19">
                  <label htmlFor="name-6" className="form-input-label">
                    Category
                  </label>
                </div>
                <select
                  id="field-11"
                  name="category"
                  data-name="Field 11"
                  value={mentor?.metadata?.category}
                  className="select-field-5 w-select"
                  onChange={handleChange}
                >
                  <option value="">Select a category</option>
                  {mentorCategories.map((category, index) => (
                    <option
                      key={`mentor-category-option-${index}`}
                      value={category?.name}
                    >
                      {category?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="w-layout-vflex flex-block-83">
              <div className="w-layout-vflex input-block invite-user-secret-block edit-mentor-settings-form-input-block">
                <div className="w-layout-hflex flex-block-19">
                  <label className="form-input-label" htmlFor="name-6">
                    Image
                  </label>
                </div>
                <div
                  className={`w-layout-hflex mentor-image-uploader ${mentorImgSrc ? '' : 'empty'}`}
                  onClick={mentorImgSrc ? console.log : handleTriggerFileUpload}
                >
                  {mentorImgSrc ? (
                    <div
                      className="w-layout-hflex upload-img-box"
                      data-w-id="3d85f56c-c65d-b956-7f38-bd18ab5e5ba8"
                      style={{
                        background: `url(${mentorImgSrc})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '50%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      <div className="w-layout-hflex upload-action-btn-container">
                        <img
                          alt=""
                          className="upload-action-btn-icon view"
                          loading="lazy"
                          src="/images/eye-1.svg"
                          style={{ display: 'none' }}
                        />
                        <img
                          alt=""
                          className="upload-action-btn-icon remove"
                          loading="lazy"
                          title="Remove image"
                          onClick={handleRemoveImage}
                          src="/images/trash-2.svg"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="w-layout-hflex upload-text-box">
                      <div className="text-block-52">+ Upload</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="w-layout-hflex flex-block-20">
            <div className="w-layout-vflex input-block invite-user-secret-block edit-mentor-settings-form-input-block horizontal-flex gap-20">
              <div className="w-layout-hflex flex-block-19">
                <label id="featured-mentor-label" className="form-input-label">
                  Featured Mentor
                </label>
              </div>
              <div className="user-row-switcher-embed justify-start-flex w-embed">
                <label
                  className="user-switcher"
                  htmlFor="featured-mentor-toggle"
                >
                  <input
                    id="featured-mentor-toggle"
                    onChange={handleCheckChange}
                    name="featured"
                    defaultChecked={
                      mentor?.settings?.mentor_visibility ===
                      'viewable_by_tenant_students'
                    }
                    type="checkbox"
                    aria-labelledby="featured-mentor-label"
                    role="switch"
                    aria-checked={
                      mentor?.settings?.mentor_visibility ===
                      'viewable_by_tenant_students'
                    }
                  />
                  <span
                    className="user-switcher-slider round"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">
                    {mentor?.settings?.mentor_visibility ===
                    'viewable_by_tenant_students'
                      ? 'Featured mentor enabled'
                      : 'Featured mentor disabled'}
                  </span>
                </label>
              </div>
            </div>
            <SubmitBtn
              onClick={
                userIsOnTrial()
                  ? handleOpenFreeTrialModal
                  : !saving
                    ? handleSubmit
                    : () => {}
              }
              href="#"
              saving={saving}
            />
          </div>
          <div className="w-embed">
            <label
              htmlFor="input-mentor-image-upload"
              className="form-label sr-only"
            >
              Profile Image
            </label>
            <input
              accept="image/*"
              className="input-mentor-image-upload"
              id="input-mentor-image-upload"
              name="uploaded_profile_image"
              type="file"
              onChange={handleFileChange}
              aria-describedby="image-upload-instructions"
              aria-required={false}
            />
            <div
              id="image-upload-instructions"
              className="form-instructions sr-only"
            >
              Please upload a profile image in JPG, PNG, or WebP format. Maximum
              file size is 5MB.
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
